import cookie  from 'js-cookie';

const set = (name, value, options) => {
    return cookie.set(name, value, options);
};

const get = (name) => {
    return cookie.get(name);
};

const remove = (name, options) => {
    return cookie.remove(name, options);
};

const exports = { set, get, remove };

export default exports;
